import React, { Component } from 'react';
import {
    isMultiColorActive,
    defaultColor,
    themeColorStorageKey,
    isDarkSwitchActive,
} from '../../../constants/defaultValues';
import THEME_COLOR from '../../../constants/themeColor';
import { TableChairs } from '../../../components/svg';

const color =
    (isMultiColorActive || isDarkSwitchActive) &&
    localStorage.getItem(themeColorStorageKey)
        ? localStorage.getItem(themeColorStorageKey)
        : defaultColor;

const THEME_COLOR_STYLE = {
    hide: {
        // hide, not setting yet
        key: 0,
        chair_fill: 'none',
        chair_stroke: 'none',
        table_fill: 'none',
        table_stroke: 'none',
    },
    default: {
        // mac dinh
        key: 1,
        chair_fill: 'none',
        chair_stroke: THEME_COLOR[color].primary,
        table_fill: 'none',
        table_stroke: THEME_COLOR[color].primary,
    },
    busy: {
        // co khach
        key: 2,
        chair_fill: THEME_COLOR[color].theme,
        chair_stroke: THEME_COLOR[color].theme,
        table_fill: 'none',
        table_stroke: THEME_COLOR[color].theme,
    },
    order: {
        // co order
        key: 3,
        chair_fill: 'none',
        chair_stroke: THEME_COLOR[color].theme,
        table_fill: THEME_COLOR[color].theme,
        table_stroke: THEME_COLOR[color].theme,
    },
    orders: {
        // orders ghep ban
        key: 4,
        chair_fill: 'none',
        chair_stroke: THEME_COLOR[color].theme,
        table_fill: THEME_COLOR[color].theme,
        table_stroke: 'none',
    },
    disabled: {
        // disabled
        key: 5,
        chair_fill: 'none',
        chair_stroke: '#ccc',
        table_fill: '#ccc',
        table_stroke: THEME_COLOR[color].primary,
    },
};
export default class TableChairIcon extends Component {
    render() {
        const { theme, id_table } = this.props;

        return <TableChairs id_table={id_table} s={THEME_COLOR_STYLE[theme]} />;
    }
}
